import {Button, FormControl, FormLabel, Grid, MenuItem, Paper, TextField, Typography} from "@mui/material";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import {useLocation, useNavigate} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import CustomModalBL from "../../component/CustomModalBL";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {yupResolver} from "@hookform/resolvers/yup";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {DatePicker} from "@mui/x-date-pickers";
import {STATUS_CREATED, THEFT} from "../../component/Constants";
import AsyncAutocomplete from "../../component/AsyncAutocomplete";
import RadioGroupComponent from "../../component/RadioGroupComponent";
import * as Yup from "yup";
import {useTheftMisappropriationActions} from "../../service/useTheftMisappropriationActions";
import {useHasScope} from "../../../../config/globalConfig";
import NotAuthorizedDialog from "../../../authentication/component/NotAuthorizedDialog";
import {THEFT_MISAPPROPRIATION_SCOPE_CREATE} from "../../component/utils/AuthConstants";
import {FormSelect} from "../../common/FormSelect";

const TheftMisappropriationEventCard = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const {t: tg} = useTranslation("translation");

    type Nullable<T> = T | null;
    const navigate = useNavigate();
    const backToList = '/finessecurity/theft-misappropriation';
    const [openCancelCreateEventCard, setOpenCancelCreateEventCard] = useState(false);
    const {globalData: {user}, dispatchGlobalData} = useContext(GlobalContext);
    const {createEventCard, searchRentalAgreement, getRentalAgreementById} = useTheftMisappropriationActions();

    const hasScope = useHasScope;
    const location = useLocation();
    const locationState = (location.state as Nullable<{ raExt: any | undefined }>);
    const raExt = locationState?.raExt;

    const legalEntityOptions: any[] = user.legalEntities
        ?.filter((x: any) => x.name.toLowerCase() !== "all")
        .map((x: any) => ({
            value: x.name,
            label: tg(`legalEntities.${x.name}`),
        }));


    const dealerOptions: any[] = user.dealers
        ?.filter((x: any) => x.name.toLowerCase() !== "all")
        .map((x: any) => ({
            value: x.name,
            label: tg(`dealers.${x.name}`),
        }));
    const [dealers, setDealers] = useState<any[]>(dealerOptions);

    const radioButtonOptions = [{
        id: 0,
        label: `${t("eventCard.theft")}`
    }, {
        id: 1,
        label: `${t("eventCard.misappropriation")}`
    }];

    const retrieveInitialValues = () => {

        return {
            eventType: {eventTypeCode: THEFT.toString()},
            eventStatus: {eventStatusCode: STATUS_CREATED.toString()},
            rentalAgreement: raExt ? raExt : "",
            plate: "",
            firstName: "",
            lastName: "",
            idFirstDriver: "",
            idAdditionalDriver: "",
            customerId: "",
            eventCountry: "",
            eventRegion: "",
            eventCity: "",
            eventProvince: "",
            eventAddress: "",
            eventDatetime: null,
            complaintDatetime: null,
            complaintAuthority: "",
            prosecutionNumber: "",
            tenant: legalEntityOptions.length == 1 ? legalEntityOptions[0].value : "",
            dealer: dealerOptions.length == 1 ? dealerOptions[0].value : "",
        };


    }

    const validationSchema = Yup.object({
        eventDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')),
        complaintDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')),
        tenant: Yup.string().required(),
        dealer: Yup.string().required()
    });


    const {handleSubmit, control, watch, formState, setValue} = useForm({
        defaultValues: retrieveInitialValues(),
        resolver: yupResolver(validationSchema)
    });
    const {isDirty: formIsDirty} = formState;

    const [rentalAgreementValues, setRentalAgreementValues] = useState<any>(watch(["rentalAgreement"]));

    const handleChangeLegalEntities = (value: any) => {
        if (value == '') {
            setDealers([]);
            setValue("rentalAgreement", "");
            setRentalAgreementValues([]);
            emptyValues();
            return;
        }
        let dealers = user?.dealers
            ?.filter(
                (x: any) =>
                    x.legalEntities.some((e: any) => value == e.name) &&
                    x.name.toLowerCase() !== "all"
            )
            .map((x: any) => {
                return {
                    label: tg(`dealers.${x.name}`),
                    value: x.name,
                };
            });
        setDealers(dealers);
        setRentalAgreementValues([]);
        setValue("rentalAgreement", "");
        emptyValues();
    }

    useEffect(() => {
        if (!rentalAgreementValues) {
            emptyValues()
        }
    }, [rentalAgreementValues]);

    useEffect(() => {
        if (watch("rentalAgreement")) {
            getRentalAgreementById(watch("rentalAgreement")).then(res => {
                if (res) {
                    setValue("plate", res.vehicle?.plate?.code);
                    setValue("firstName", res.raOwner?.firstName);
                    setValue("lastName", res.raOwner?.lastName);
                    setValue("customerId", res.raOwner?.customerId);
                    setValue("idFirstDriver", res.firstDriver?.customerId);
                    setValue("idAdditionalDriver", res.driver?.customerId);
                    setValue("tenant", res.idTenant);
                    setValue("dealer", res.dealer);
                }
            });
        }
    }, [watch("rentalAgreement")]);


    const onSubmit = async (values: any) => {
        if (!values.rentalAgreement && !values.plate) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("updateForm.requiredFieldsError"),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
            return;
        }

        let payload = {...values, plate: values.plate.replaceAll(' ', '')};
        let data = await createEventCard(payload);
        if (data) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("updateForm.eventCreatedMsg"),
                        type: snackbarTypes.success,
                        show: true,
                        autoClose: true,
                    }
                }
            });
            navigate(backToList);
        } else {

        }
    }

    function emptyValues() {
        setValue("plate", '');
        setValue("firstName", '');
        setValue("lastName", '');
    }

    return (
        <>
            {hasScope(THEFT_MISAPPROPRIATION_SCOPE_CREATE) ?
                <>
                    <SectionHeader title={t('eventCard.addEventCardTitle')}
                                   subtitle={t('eventCard.addEventCardSubTitle')}/><Paper elevation={3} sx={{
                    padding: "16px",
                    margin: "18px"
                }}>
                    <form onSubmit={handleSubmit(data => {
                        onSubmit({...data});
                    }, errors => console.log(errors))} noValidate>

                        <Grid>
                            <Grid item xs={12}>
                                <Controller
                                    control={control}
                                    name={"eventType.eventTypeCode"}
                                    render={({field, fieldState}) => (
                                        <FormControl>
                                            <FormLabel
                                                id="demo-radio-buttons-group-label">
                                                {t('eventCard.selectEvent').toUpperCase()}</FormLabel>

                                            <RadioGroupComponent
                                                handleChange={field.onChange}
                                                options={radioButtonOptions}
                                                disabled={false}
                                                value={field.value}
                                                name={"eventType.eventTypeCode"}/>
                                        </FormControl>
                                    )}/>
                            </Grid>
                        </Grid>

                        <Grid container rowSpacing={3} columnSpacing={3}>
                            <Grid item md={3} sm={3} xs={12}>
                                <FormSelect
                                    name={"tenant"}
                                    control={control}
                                    props={{
                                        label: tg("shared.legalEntity"),
                                        fullWidth: true,
                                        required: true,
                                        onChange: (e: any) => {
                                            handleChangeLegalEntities(e.target.value)
                                        },
                                    }}

                                    items={legalEntityOptions.map((option: any) => (
                                        <MenuItem key={option.value}
                                                  value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                />
                            </Grid>
                            <Grid item md={3} sm={3} xs={12}>
                                <FormSelect
                                    name={"dealer"}
                                    control={control}
                                    props={{
                                        label: tg("shared.dealer"),
                                        fullWidth: true,
                                        required: true,
                                        disabled: dealers.length == 0
                                    }}
                                    items={dealers.map((option: any) => (
                                        <MenuItem key={option.value}
                                                  value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                />
                            </Grid>

                        </Grid>
                        <Typography align="left">  {t('eventCard.enterRentalAgreement').toUpperCase()} </Typography>

                        <Grid container rowSpacing={3} columnSpacing={3}>

                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"rentalAgreement"}
                                    render={({field, fieldState}) => (
                                        <AsyncAutocomplete id={"rentalAgreement"}
                                                           value={field.value}
                                                           disabled={!watch("tenant")}
                                                           callback={(search) => searchRentalAgreement(search, watch("tenant"), watch("dealer"))}
                                                           tenant={watch("tenant")}
                                                           dealer={watch("dealer")}
                                                           onChange={field.onChange}
                                                           renderInput={(params) =>
                                                               <TextField
                                                                   {...params}
                                                                   label={t('eventCard.rentalAgreement')}
                                                                   disabled={!watch("tenant")}
                                                                   error={!!fieldState.error}
                                                                   helperText={fieldState.error?.message}
                                                               />
                                                           }
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"plate"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth label={t('eventCard.plate')}
                                            disabled={!!rentalAgreementValues}
                                            value={field.value} margin="dense" variant="standard"
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}/>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"firstName"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth label={t('customerDetails.firstName')}
                                            disabled={!!rentalAgreementValues}
                                            value={field.value} margin="dense" variant="standard"
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}/>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"lastName"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth label={t('customerDetails.lastName')}
                                            disabled={!!rentalAgreementValues}
                                            value={field.value} margin="dense" variant="standard"
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}/>
                                    )}/>
                            </Grid>


                            <Grid item xs={12}>
                                <Typography align="left">  {t('eventCard.eventLocation').toUpperCase()}  </Typography>
                                <Grid container rowSpacing={3} columnSpacing={3}>
                                    <Grid item xs={3}>
                                        <Controller
                                            control={control}
                                            name={"eventCountry"}
                                            render={({field, fieldState}) => (
                                                <TextField
                                                    fullWidth label={t('eventCard.country')}
                                                    value={field.value} margin="dense" variant="standard"
                                                    onChange={field.onChange}
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}/>
                                            )}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Controller
                                            control={control}
                                            name={"eventRegion"}
                                            render={({field, fieldState}) => (
                                                <TextField fullWidth label={t('eventCard.region')}
                                                           value={field.value} margin="dense" variant="standard"
                                                           onChange={field.onChange}
                                                           error={!!fieldState.error}
                                                           helperText={fieldState.error?.message}/>
                                            )}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Controller
                                            control={control}
                                            name={"eventCity"}
                                            render={({field, fieldState}) => (
                                                <TextField fullWidth label={t('eventCard.city')}
                                                           value={field.value} margin="dense" variant="standard"
                                                           onChange={field.onChange}
                                                           error={!!fieldState.error}
                                                           helperText={fieldState.error?.message}/>
                                            )}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Controller
                                            control={control}
                                            name={"eventProvince"}
                                            render={({field, fieldState}) => (
                                                <TextField fullWidth label={t('eventCard.province')}
                                                           value={field.value} margin="dense" variant="standard"
                                                           onChange={field.onChange}
                                                           error={!!fieldState.error}
                                                           helperText={fieldState.error?.message}/>
                                            )}/>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Controller
                                            control={control}
                                            name={"eventAddress"}
                                            render={({field, fieldState}) => (
                                                <TextField fullWidth label={t('eventCard.address')}
                                                           value={field.value} margin="dense" variant="standard"
                                                           onChange={field.onChange}
                                                           error={!!fieldState.error}
                                                           helperText={fieldState.error?.message}/>
                                            )}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Controller
                                            control={control}
                                            name={"prosecutionNumber"}
                                            render={({field, fieldState}) => (
                                                <TextField fullWidth name="prosecutionNumber"
                                                           label={t('eventCard.prosecutionNumber')}
                                                           value={field.value} margin="dense" variant="standard"
                                                           onChange={field.onChange}
                                                           error={!!fieldState.error}
                                                           helperText={fieldState.error?.message}/>
                                            )}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Controller
                                            control={control}
                                            name={"complaintAuthority"}
                                            render={({field, fieldState}) => (
                                                <TextField fullWidth name="complaintAuthority"
                                                           label={t('eventCard.complaintAuthority')}
                                                           value={field.value} margin="dense" variant="standard"
                                                           onChange={field.onChange}
                                                           error={!!fieldState.error}
                                                           helperText={fieldState.error?.message}/>
                                            )}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Controller
                                            control={control}
                                            name={"eventDatetime"}
                                            render={({field, fieldState}) => (
                                                <DatePicker
                                                    label={t('eventCard.dateOfEvent')}
                                                    value={field.value}
                                                    onChange={field.onChange}
                                                    renderInput={(params) => <TextField
                                                        {...params}
                                                        fullWidth
                                                        error={!!fieldState.error}
                                                        helperText={fieldState.error?.message}/>}
                                                    inputFormat={"L"}/>
                                            )}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Controller
                                            control={control}
                                            name={"complaintDatetime"}
                                            render={({field, fieldState}) => (
                                                <DatePicker
                                                    label={t('eventCard.dateOfComplaint')}
                                                    value={field.value}
                                                    onChange={field.onChange}
                                                    renderInput={(params) => <TextField
                                                        {...params}
                                                        fullWidth
                                                        error={!!fieldState.error}
                                                        helperText={fieldState.error?.message}/>}
                                                    inputFormat={"L"}/>
                                            )}/>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>

                        {/*Buttons management*/}
                        <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                            <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                                  justifyContent={"flex-end"}>
                                <Grid item>
                                    <Button variant={"outlined"} color={"accent"}
                                            onClick={() => {
                                                formIsDirty ?
                                                    setOpenCancelCreateEventCard(true) : navigate(backToList);
                                            }}
                                    >
                                        {t('buttons.cancel')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button color={"accent"} type="submit">{t('buttons.createCard')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>
                    <CustomModalBL title={t('modaleMsg.unsavedChanges')}
                                   content={t('modaleMsg.discardCardMessage')}
                                   cancelButton={t('modaleMsg.discardChanges')}
                                   saveButton={t('modaleMsg.keepEditing')}
                                   isDisabled={false}
                                   open={openCancelCreateEventCard}
                                   titleIcon={<InfoRoundedIcon/>}
                                   onClose={() => {
                                       setOpenCancelCreateEventCard(false);
                                   }}
                                   onSave={() => {
                                       setOpenCancelCreateEventCard(false);
                                   }}
                                   onCancel={() => {
                                       setOpenCancelCreateEventCard(false);
                                       navigate(backToList);
                                   }}/>
                </>
                : <NotAuthorizedDialog/>
            }
        </>
    );

}
export default TheftMisappropriationEventCard;